import { render, staticRenderFns } from "./SetupConfirmation.vue?vue&type=template&id=17845e52&scoped=true&"
import script from "./SetupConfirmation.vue?vue&type=script&lang=js&"
export * from "./SetupConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17845e52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.7m6CVIT2x327/twofactor_totp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17845e52')) {
      api.createRecord('17845e52', component.options)
    } else {
      api.reload('17845e52', component.options)
    }
    module.hot.accept("./SetupConfirmation.vue?vue&type=template&id=17845e52&scoped=true&", function () {
      api.rerender('17845e52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SetupConfirmation.vue"
export default component.exports